import editIcon from '../../../assets/icons/edit-icon.svg';
import editIconWithColor from '../../../assets/icons/edit-icon-with-color.svg';
import classes from './EditButton.module.css';

interface Props {
  onClick: () => void;
  variant?: 'default' | 'withFill';
}

const EditButton: React.FC<Props> = ({ onClick, variant }) => {
  return (
    <img
      src={variant === 'withFill' ? editIconWithColor : editIcon}
      className={classes.container}
      onClick={onClick}
      alt="Edit"
    />
  );
};

export default EditButton;
